import React, { useContext } from 'react'
import { LayoutContext } from '../context/layoutContext'

export const useLayout = () => {
  return useContext(LayoutContext);
}
